/* eslint-disable react-hooks/exhaustive-deps */

import { withStyles } from '@material-ui/core';

import { Box } from '@mui/material';

import { compose } from 'recompose';
import { connect } from 'react-redux';
import FullscreenSpinner from 'modules/common/fullscreenSpinner.component';
import React, { useEffect, useState } from 'react';

import { getVendorLogs } from './store/activityLog.actions';
import { GET_ACTIVITY_LOG_VENDOR_FAILURE } from './store/activityLog.types';

import { TOAST_MESSAGE_SEVERITY_ERROR } from 'modules/layout/types';
import ActivityLogComponent from './activityLog.component';
import { getAllCountries } from 'country-locale-map';
import {
  getAllCurrencies,
  getAllEnumerations,
  getAllProvinces,
  getAllSaleTypes,
  getAllWeightTypes
} from 'modules/enumerations/store/enumerationActions';
import { fetchEnumerations } from 'modules/authorizations/utils/fetchDataDetailsService';

const styles = theme => ({
  wideControl: {
    minWidth: 174
  },
  section: {
    marginBottom: theme.spacing(2)
  },
  selfServicePolicySelect: {
    minWidth: 300
  }
});

const VendorActivityLogView = props => {
  const vendorIdParam = props.match?.params?.vendorId ?? '0';
  const vendorId = Number.parseInt(vendorIdParam, 10);

  const [logs, setLogs] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    async function fetchData() {
      setIsLoading(true);
      await fetchEnumerations(props);
      const response = await props.getVendorLogs(vendorId);
      if (response.type === GET_ACTIVITY_LOG_VENDOR_FAILURE) {
        props.showToast('Failed to retrieve activity logs for this vendor.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      } else {
        setLogs(response.response);
      }
      setIsLoading(false);
    }

    fetchData();
  }, []);

  return (
    <Box>
      {!isLoading && logs && (
        <Box sx={{ padding: 3 }}>
          <ActivityLogComponent logs={logs} enumerations={props.enumerations ? props.enumerations.allEnums : {}} />
        </Box>
      )}
      {isLoading && <FullscreenSpinner />}
    </Box>
  );
};
const mapStateToProps = state => {
  const enumerations = state.enumerations;
  return {
    enumerations
  };
};

export default compose(
  withStyles(styles),
  connect(mapStateToProps, {
    getVendorLogs,
    getAllEnumerations,
    getAllSaleTypes,
    getAllWeightTypes,
    getAllProvinces,
    getAllCurrencies,
    getAllCountries
  })
)(VendorActivityLogView);
